<template>
    <div>
        <MqLayout mq="md+">
            <div
                v-if="screeningQuestions.length > 0"
                class="af-screening-question-container afu-flex afu-flex-col afu-items-center afu-mt-10"
            >
                <div
                    v-if="!submited"
                    class="af-screening-question-content"
                    :class="{ 'full-width' : onApplyPage == true }"
                >
                    <ValidationObserver
                        ref="submitForm"
                        tag="form"
                        @submit.stop.prevent="onSubmit"
                    >
                        <div class="screening-question-background-wrap afu-shadow-card">
                            <div class="screening-question-heading afu-inline-flex afu-mb-8">
                                <div class="sparkle-icon afu-mr-5">
                                    <FontAwesomeIcon
                                        :icon="['far', 'sparkles']"
                                        size="2x"
                                        class="afu-mr-2 md:afu-mr-3 afu-mt-2 afu-sparkle-icon"
                                    />
                                </div>
                                <div class="heading-title">
                                    <div class="afu-text-secondary-dark afu-font-bold primary-title">{{ $t('screening.title') }}</div>
                                    <div>{{ $t('screening.sub_title') }}</div>
                                </div>
                            </div>
                            <div class="screening-question-content">
                                <div class="custom-candidate-attributes">
                                    <CustomAttributeInput
                                        v-for="(attr, index) in screeningQuestions"
                                        :key="`screening_question_${attr.id}_${index}`"
                                        :attr="attr"
                                        @changed="changedCustomAttribute"
                                    />
                                </div>
                            </div>
                        </div>
                        <div 
                            v-if="showSubmitButton" 
                            class="screening-question-btn afu-mt-10 afu-flex afu-flex-col"
                        >
                            <C1Button
                                :disabled="loader.updating"
                                :is-busy="loader.updating"
                                type="submit"
                                variant="primary"
                                size="lg"
                            >
                                {{ submitButtonText }}
                                <FontAwesomeIcon
                                    :icon="['fas', 'arrow-right']"
                                    size="xl"
                                    class="afu-ml-2 md:afu-ml-2"
                                />
                            </C1Button>
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </MqLayout>
        <MqLayout mq="sm">
            <div
                v-if="screeningQuestions.length > 0"
                class="af-screening-question-container afu-flex afu-flex-col afu-items-center afu-mt-10"
            >
                <div
                    v-if="!submited"
                    class="af-screening-question-content mobile-view"
                >
                    <ValidationObserver
                        ref="submitForm"
                        tag="form"
                        @submit.stop.prevent="onSubmit"
                    >
                        <div class="screening-question-background-wrap afu-shadow-card">
                            <div class="screening-question-heading afu-inline-flex afu-mb-8">
                                <div class="sparkle-icon afu-mr-5">
                                    <FontAwesomeIcon
                                        :icon="['far', 'sparkles']"
                                        size="2x"
                                        class="afu-mr-2 md:afu-mr-3 afu-mt-2 afu-sparkle-icon"
                                    />
                                </div>
                                <div class="heading-title">
                                    <div class="afu-text-secondary-dark afu-font-bold primary-title">
                                        {{ $t('screening.title') }}
                                    </div>
                                    <div>
                                        {{ $t('screening.sub_title') }}
                                    </div>
                                </div>
                            </div>
                            <div class="screening-question-content">
                                <div class="custom-candidate-attributes">
                                    <CustomAttributeInput
                                        v-for="(attr, index) in screeningQuestions"
                                        :key="`screening_question_${attr.id}_${index}`"
                                        :attr="attr"
                                        @changed="changedCustomAttribute"
                                    />
                                </div>
                            </div>
                        </div>
                        <div 
                            v-if="showSubmitButton" 
                            class="screening-question-btn afu-mt-10 afu-flex afu-flex-col"
                        >
                            <C1Button
                                :disabled="loader.updating"
                                :is-busy="loader.updating"
                                type="submit"
                                variant="primary"
                                size="lg"
                            >
                                {{ submitButtonText }}
                                <FontAwesomeIcon
                                    :icon="['fas', 'arrow-right']"
                                    size="xl"
                                    class="afu-ml-2 md:afu-ml-2"
                                />
                            </C1Button>
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </MqLayout>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import '@/plugins/vee-validate';
    import { ValidationObserver } from 'vee-validate';
    import C1Button from '@/components/C1Components/C1Button';
    import CustomAttributeInput from '@/components/Seeker/CustomAttributeInput';

    export default {
        name: 'ScreeningQuestion',

        components: {
            ValidationObserver,
            CustomAttributeInput,
            C1Button,
            // C1Label,
        },

        props: {
            jobUuid: {
                type: String,
                required: true,
                default: '',
            },
            jobUrl: {
                type: String,
                default: '',
            },
            onApplyPage: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                response: {
                    variant: '',
                    message: '',
                },
                loader: {
                    updating: false,
                },
                submited: false,
                screeningQuestions: [],
                return_page: {
                    notFound: false,
                    success: false,
                },
                form: {
                    id: '',
                    title: '',
                },
                submitButtonText: '',
                submitButtonLink: '',
            };
        },

        async created() { 
            
            this.$_getScreeningQuestions(this.jobUuid)
                .then(response => {
                    if (response.data && response.data.length > 0) {
                        this.form = {
                            id: response.data.id,
                        //    title: response.data.title,
                        };
                        response.data.forEach(attr => {
                            if (attr.type === 'select') {
                                let op;

                                if (attr.misc?.typeahead) {
                                    op = attr.value;
                                    attr.model = attr.value?.label;
                                } else {
                                    op = attr.options.find(
                                        op => op.id == attr.value,
                                    );
                                }

                                if (op) {
                                    attr.value = { ...op };
                                } else {
                                    attr.value = null;
                                }
                            }

                            if (attr.type === 'multiselect') {
                                if (Array.isArray(attr.value)) {
                                    attr.value = attr.value.map(op => {
                                        const option = attr.options.find(
                                            ele => ele.id == op,
                                        );
                                        return {
                                            id: option.id,
                                            label: option.label,
                                            is_selected: true,
                                        };
                                    });
                                } else {
                                    attr.value = [];
                                }
                            }

                            if (attr.type === 'file' || attr.type === 'image') {
                                if (attr.file) {
                                    attr.value = {
                                        name: attr.file.filename,
                                        lastModifiedDate: attr.file.updated_at,
                                        uuid: attr.file.uuid,
                                        size: attr.file.size,
                                        extension: attr.file.filename
                                            .split('.')
                                            .pop(),
                                    };
                                } else {
                                    attr.value = null;
                                }
                            }
                        });
                        this.screeningQuestions = response.data;
                        console.log(this.screeningQuestions);
                    }
                })
                .catch(() => {
                    this.submited = true;
                })
                .finally(() => {
                    this.initialized = true;
                });

            this.$_getScreeningQuestionSet(this.jobUuid)
                .then(response => {
                    if (response.data) {
                        this.submitButtonText= response.data.options.submitButtonSettings.submitButtonText;
                        this.submitButtonLink= response.data.options.submitButtonSettings.submitButtonLink;
                    }
                });
        },

        computed: {
            showSubmitButton() {
                return !this.onApplyPage;
            },
        },

        watch: {},

        async mounted() {
            this.submitButtonText = this.submitButtonText ? this.submitButtonText : this.$t('screening.confirm_and_finish');
        },

        methods: {
            ...mapActions('job', {
                $_getScreeningQuestions: 'getScreeningQuestions',
                $_saveScreeningQuestionResponses: 'saveScreeningQuestionResponses',
                $_getScreeningQuestionSet: 'getScreeningQuestionSet',
            }),

            async onSubmit() {
                const validate = await this.$refs.submitForm.validate();
                if (!validate) {
                    return;
                }

                this.loader.updating = true;

                const customAttributes = this.screeningQuestions.map(attribute => {
                    const ele = { ...attribute };
                    if (ele.type == 'multiselect') {
                        ele.value = ele.value?.map(value => value.id);
                    }
                    if (ele.type == 'select') {
                        ele.value = ele.value?.id;
                    }
                    if (ele.type == 'checkbox') {
                        ele.value = ele.value ? 1 : 0;
                    }

                    if (ele.type == 'file' || ele.type == 'image') {
                        ele.value = ele.value?.uuid ? ele.value.uuid : ele.value;
                    }

                    if (!ele.value) {
                        ele.value = null;
                    }

                    return ele;
                });
                const screenQuestions = customAttributes
                    .filter(ele => {
                        return (
                            ele.questionable_type == 'screen_question' ||
                            ele.questionable_type == 'custom_field'
                        );
                    })
                    .map(ele => {
                        return {
                            id: ele.id,
                            value: ele.value,
                        };
                    });

                let formData = screenQuestions;
                // formData = { ...formData};
                this.$_saveScreeningQuestionResponses({
                    jobUuid: this.jobUuid,
                    formData: formData,
                })
                    .then(response => {
                        if (response) {
                            this.response.variant = 'success';
                            this.response.message =
                                'response submitted successfully.';
                            this.submited = true;
                            this.return_page.success = true;
                            if (!this.onApplyPage) {
                                this.submitButtonLink ? this.goToCustomLink() : this.goBackToJobView();
                            }
                        }
                    })
                    .catch(() => {
                        this.response.message =
                            'Can not responses, please refresh and try again.';
                        this.response.variant = 'danger';
                        this.loader.updating = false;
                    })
                    .finally(() => {
                        this.loader.updating = false;
                    });
            },

            goBackToJobView() {
                window.location.href = this.jobUrl;
            },

            goToCustomLink() {
                const domain =`https://${window.location.hostname}`;
                window.location.href = domain+this.submitButtonLink;
            },

            changedCustomAttribute() { },

            getResponses() {
                if (this.screeningQuestions.length === 0) {
                    return null;
                }

                const validate = this.$refs.submitForm.validate();
                if (!validate) {
                    return;
                }

                this.loader.updating = true;

                const customAttributes = this.screeningQuestions.map(attribute => {
                    const ele = { ...attribute };
                    if (ele.type == 'multiselect') {
                        ele.value = ele.value?.map(value => value.id);
                    }
                    if (ele.type == 'select') {
                        ele.value = ele.value?.id;
                    }
                    if (ele.type == 'checkbox') {
                        ele.value = ele.value ? 1 : 0;
                    }

                    if (ele.type == 'file' || ele.type == 'image') {
                        ele.value = ele.value?.uuid ? ele.value.uuid : ele.value;
                    }

                    if (!ele.value) {
                        ele.value = null;
                    }

                    return ele;
                });
                const screenQuestions = customAttributes
                    .filter(ele => {
                        return (
                            ele.questionable_type == 'screen_question' ||
                            ele.questionable_type == 'custom_field'
                        );
                    })
                    .map(ele => {
                        return {
                            id: ele.id,
                            value: ele.value,
                        };
                    });
                return screenQuestions;
            },
        },
    };
</script>
<style lang="scss" scoped>
    .af-screening-question-container {
        .afu-sparkle-icon {
            color: #ffd700;
        }

        .primary-title {
            font-size: 18px;
        }

        .screening-question-background-wrap {
            background-color: #fff;
            padding: 30px 30px 10px;
        }

        .af-screening-question-content {
            width: 55%;
        }

        .af-screening-question-content.mobile-view {
            width: 100%;
        }

        .af-screening-question-content.full-width {
            width: 100%;
        }
    }
</style>
